import { render, staticRenderFns } from "./OpinionList.vue?vue&type=template&id=016a8d42&scoped=true"
import script from "./OpinionList.vue?vue&type=script&lang=js"
export * from "./OpinionList.vue?vue&type=script&lang=js"
import style0 from "./OpinionList.vue?vue&type=style&index=0&id=016a8d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016a8d42",
  null
  
)

export default component.exports